"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof3 = require("/var/www/html/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/es6.weak-map");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _slicedToArray2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _typeof2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
require("core-js/modules/es7.object.entries");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.freeze");
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
var XLSX = _interopRequireWildcard(require("xlsx/xlsx.mjs"));
var _pattern = require("@/api/pattern");
var _ratioManage = _interopRequireDefault(require("./components/ratio-manage"));
var _oneButtonManage = _interopRequireDefault(require("./components/one-button-manage"));
var _presetOneButtonManage = _interopRequireDefault(require("./components/preset-one-button-manage"));
var _customTable = _interopRequireDefault(require("./components/custom-table"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 一键配置
// 预设配置
var _default = exports.default = {
  components: {
    RatioManage: _ratioManage.default,
    OneButtonManage: _oneButtonManage.default,
    PresetOneButtonManage: _presetOneButtonManage.default,
    CustomTable: _customTable.default
  },
  data: function data() {
    return {
      tableData: [],
      totalPage: 1,
      currentPage: 1,
      perPage: 30,
      totalNumber: 0,
      // 总数量
      searchChannel: '',
      // 搜索渠道
      searchProductIdList: [],
      // 搜索产品ID列表
      searchPattern: '',
      // 搜索模型
      searchConfigType: '',
      // 搜索配置类型，从0开始
      configTypeList: [],
      // 配置类型列表
      presetConfigList: {},
      // 预设配置列表
      manageType: '',
      // 弹窗操作类型 add-新增 modify-修改 modifyMulti-批量修改 modifyAll-一键修改
      chooseData: {},
      styleList: ['', 'success', 'warning', 'danger', 'info'],
      patternList: [],
      // 模型列表
      loading: true,
      multipleSelection: [],
      // 批量操作勾选列表
      changeStateList: [],
      forbidModifyFlag: 1 // 禁止修改的标识
    };
  },
  computed: (0, _vuex.mapState)({
    all_products: function all_products(state) {
      var products = _lodash.default.cloneDeep(state.common.all_products);
      var item = {
        id: 'all',
        name: '全部测算'
      };
      if (products) {
        // 过滤无 app_id 的测算
        products = products.filter(function (item) {
          return !!item.app_id;
        });
        products.unshift(item);
      }
      return products;
    }
  }),
  mounted: function mounted() {
    this.getAllPatternList();
    if (!this.all_products) {
      this.getAllProducts();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)({
    getAllProducts: 'common/getAllProducts'
  })), {}, {
    getAllPatternList: function getAllPatternList() {
      var _this = this;
      var params = {
        page: 1,
        // 因为要拿到全部的模型数据，所以per_page设置稍微大些，后面如果有超过100的情况再调整
        per_page: 300
      };
      (0, _pattern.getPatternList)(params).then(function (_ref) {
        var code = _ref.code,
          data = _ref.data;
        if (code === 200) {
          var list = data.list;
          var newList = [];
          var _iterator = _createForOfIteratorHelper(list),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              var newItem = _objectSpread(_objectSpread({}, item), {}, {
                label: item.remark,
                value: item.id
              });
              newList.push(newItem);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this.patternList = newList;
          // 拿到模型列表再去请求配置列表
          _this.getList();
          // 请求配置类型列表
          _this.getConfigTypeList();
        }
      });
    },
    getList: function getList() {
      var _this2 = this;
      var params = {
        page: this.currentPage,
        per_page: this.perPage
      };
      // 筛选渠道
      if (this.searchChannel) {
        params.channel = this.searchChannel;
      }
      // 筛选模型
      if (this.searchPattern) {
        params.pattern = this.searchPattern;
      }
      // 筛选产品列表
      if (this.searchProductIdList.length > 0) {
        params.product_id = this.searchProductIdList.join(',');
      }
      // 筛选配置类型
      if (typeof this.searchConfigType === 'number') {
        params.class = this.searchConfigType;
      }
      (0, _pattern.getProductPatternList)(params).then(function (_ref2) {
        var code = _ref2.code,
          data = _ref2.data;
        if (code === 200) {
          var list = data.list,
            meta = data.meta;
          var newList = _this2.getFinalList(list);
          _this2.tableData = Object.freeze(newList);
          _this2.totalPage = meta.page.total_page;
          _this2.totalNumber = meta.page.total;
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /**
    * 获取配置类型列表
    * Tips：
    * 1、一键配置的情况，需要重新获取配置类型列表（因为一键配置更新了配置类型数据）
    * 2、新增/修改的情况，也需要重新请求，后端会拿最新的配置值更改map（容易踩坑的点）
    */
    getConfigTypeList: function getConfigTypeList() {
      var _this3 = this;
      (0, _pattern.getPatternMap)().then(function (_ref3) {
        var code = _ref3.code,
          data = _ref3.data;
        if (code === 200) {
          var change_state_map = data.change_state_map,
            class_config = data.class_config,
            class_map = data.class_map;
          var changeStateMapKeys = Object.keys(change_state_map);
          var classConfigKeys = Object.keys(class_config);
          // 配置类型处理
          _this3.configTypeList = classConfigKeys.map(function (key) {
            var item = class_config[key];
            var text = class_map[key];
            var newItem = {
              value: item.class,
              // 值
              label: text,
              // 名称
              canGuideOrders: item.keqiangdao_od ? Number(item.keqiangdao_od) : 0,
              // 可强导订单
              ratioList: _this3.getRatioListByClassConfig(item.content),
              // 模型列表
              sRatioList: item.s_content ? _this3.getRatioListByClassConfig(item.s_content) : [],
              // 第二配置模型列表
              changeState: item.change_state // 是否可修改
            };
            return newItem;
          });
          // 请求预设配置列表
          _this3.getPresetConfigListData(class_map);
          // 修改状态处理
          _this3.changeStateList = changeStateMapKeys.map(function (key) {
            var text = change_state_map[key];
            var item = {
              value: Number(key),
              label: text
            };
            return item;
          });
        }
      });
    },
    /** 获取预设配置列表
    * 
    */
    getPresetConfigListData: function getPresetConfigListData(class_map) {
      var _this4 = this;
      (0, _pattern.getPresetConfigList)().then(function (_ref4) {
        var code = _ref4.code,
          data = _ref4.data;
        if (code === 200 && data) {
          var result = Object.keys(data).reduce(function (acc, key) {
            var item = data[key];
            acc[key] = {
              value: key,
              label: class_map[key],
              itemList: item.map(function (item) {
                return {
                  date: item.date,
                  ratioList: _this4.getRatioListByClassConfig(item.content, 'preset'),
                  sRatioList: item.s_content ? _this4.getRatioListByClassConfig(item.s_content, 'preset') : [],
                  changeState: item.change_state
                };
              })
            };
            return acc;
          }, {});
          _this4.presetConfigList = Object.freeze(result);
        }
      });
    },
    getFinalList: function getFinalList(list, type) {
      var newList = [];
      for (var i = 0; i < list.length; i++) {
        var _list$i = list[i],
          app_id = _list$i.app_id,
          product_id = _list$i.product_id,
          product_name = _list$i.product_name,
          data = _list$i.data;
        for (var j = 0; j < data.length; j++) {
          var item = data[j];
          var ratioArray = this.getFormatRatioArray(item.content, item.order_count);
          var sRatioArray = item.s_content ? this.getFormatRatioArray(item.s_content, item.order_count) : [];
          // 处理预设配置值（next_content / next_s_content）
          var nextRatioArray = item.next_content ? this.getFormatNextContentArray(item.next_content) : [];
          var nextSRatioArray = item.next_s_content ? this.getFormatNextContentArray(item.next_s_content) : [];
          var newItem = _objectSpread(_objectSpread({}, item), {}, {
            app_id: app_id,
            product_id: product_id,
            product_name: product_name,
            combineAmount: j === 0 ? data.length : 0,
            // 向下合并条数
            newValue: ratioArray,
            sValue: sRatioArray,
            nextValue: nextRatioArray,
            nextSValue: nextSRatioArray
          });
          if (type === 'export') {
            newItem.joinValue = this.getJoinConfigValue(ratioArray); // 产品模型配置拼接值
          }
          newList.push(newItem);
        }
      }
      return newList;
    },
    // 获取拼接的配置值
    getJoinConfigValue: function getJoinConfigValue(list) {
      var newList = [];
      list.forEach(function (item) {
        var str = item.label + '：比例 ' + item.weight + '%，订单上限 ' + item.limit + '；';
        newList.push(str);
      });
      return newList.join('\n');
    },
    getRatioListByClassConfig: function getRatioListByClassConfig(content, type) {
      var _this5 = this;
      var ratioList = [];
      // 整合数据
      var _loop = function _loop() {
        var contentItem = content[i];
        var findItem = _this5.patternList.find(function (item) {
          return item.value === contentItem.id;
        });
        var label = findItem ? findItem.label : '';
        var basket = findItem ? findItem.basket : {};
        var limit = 0;
        if (type === 'preset') {
          limit = contentItem.o_sum;
        } else {
          limit = basket.o_sum;
        }
        var item = {
          value: contentItem.id,
          // 模型id
          label: label,
          // 模型名称
          weight: contentItem.ratios,
          // 导粉比例
          fansRate: findItem.month_fan_rate,
          // 导粉率，
          limit: limit ? Number(limit) : 0,
          // 导粉订单上限
          fans: contentItem.expected_fans // 预计导粉
        };
        ratioList.push(item);
      };
      for (var i = 0; i < content.length; i++) {
        _loop();
      }
      return ratioList;
    },
    // 获取格式化的模型比例数组数据
    getFormatRatioArray: function getFormatRatioArray(value) {
      var _this6 = this;
      var ratioData = value;
      var ratioArr = Object.entries(ratioData);
      var newRatioArr = [];

      // 比例处理，转成数组
      ratioArr.forEach(function (ratioItem) {
        var value = Number(ratioItem[0]);
        var weight = Number(ratioItem[1]);
        var label = '',
          isExceed = false,
          // 是否超上限
          limit = 0; // 订单上限
        var findItem = _this6.patternList.find(function (item) {
          return item.value === value;
        });
        if (findItem) {
          label = findItem.label;
          isExceed = findItem.is_exceed;
          if (findItem.basket) {
            limit = findItem.basket.o_sum || 0;
          }
        }
        var newRatioItem = {
          value: value,
          weight: weight,
          label: label,
          limit: limit,
          isExceed: isExceed
        };
        newRatioArr.push(newRatioItem);
      });
      return newRatioArr;
    },
    // 获取格式化的预设配置数组数据（处理next_content格式）
    getFormatNextContentArray: function getFormatNextContentArray(nextContent) {
      var _this7 = this;
      if (!nextContent || (0, _typeof2.default)(nextContent) !== 'object') {
        return [];
      }
      var newRatioArr = [];
      var entries = Object.entries(nextContent);
      entries.forEach(function (_ref5) {
        var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
          key = _ref6[0],
          item = _ref6[1];
        var value = Number(key);
        var weight = Number(item.ratios);
        var limit = Number(item.o_sum);
        var expectedFans = Number(item.expected_fans);
        var label = '';
        var findItem = _this7.patternList.find(function (pattern) {
          return pattern.value === value;
        });
        if (findItem) {
          label = findItem.label;
        }
        var newRatioItem = {
          value: value,
          weight: weight,
          label: label,
          limit: limit,
          isExceed: false,
          // 预设配置不检查超限
          expectedFans: expectedFans
        };
        newRatioArr.push(newRatioItem);
      });
      return newRatioArr;
    },
    // 搜索
    onSearch: function onSearch() {
      this.loading = true;
      // 搜索重置
      this.totalPage = 1;
      this.currentPage = 1;
      this.getList();
    },
    // 新增
    onAdd: function onAdd() {
      this.chooseData = {};
      this.manageType = 'add';
      this.$refs.managePop.dialogVisible = true;
    },
    // 重置
    onReset: function onReset() {
      location.reload();
    },
    // 导出
    onExport: function () {
      var _onExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, finalList, res, tableData, wb, ws;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                page: 1,
                per_page: 1000 // 要拿到全部数据，暂定1000，后面超出再调整
              };
              finalList = [];
              _context.next = 4;
              return (0, _pattern.getProductPatternList)(params);
            case 4:
              res = _context.sent;
              if (res.code === 200 && res.data.list) {
                finalList = this.getFinalList(res.data.list, 'export');
              }
              tableData = finalList.map(function (row) {
                return {
                  'APP ID': row.app_id,
                  产品名称: row.product_name,
                  '产品 ID': row.product_id,
                  配置类型: row.class_name,
                  渠道: row.channel_id,
                  渠道匹配模式: row.mode_name,
                  配置值: row.joinValue,
                  更新时间: row.updated_at
                };
              });
              wb = XLSX.utils.book_new();
              ws = XLSX.utils.json_to_sheet(tableData);
              XLSX.utils.book_append_sheet(wb, ws, 'sheet1');
              XLSX.writeFile(wb, "\u6743\u91CD\u5206\u53D1\u914D\u7F6E_\u4EA7\u54C1\u6743\u91CD\u5206\u53D1\u5217\u8868_".concat(Date.now(), ".xlsx"));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onExport() {
        return _onExport.apply(this, arguments);
      }
      return onExport;
    }(),
    // 删除（
    onDelete: function onDelete(val) {
      var _this8 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u8BE5\u914D\u7F6E?", '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _pattern.deleteProductPattern)(val.id).then(function (_ref7) {
          var code = _ref7.code;
          if (code === 200) {
            _this8.$message({
              type: 'success',
              message: '删除成功!'
            });
            // 更新列表
            _this8.getList();
          }
        });
      });
    },
    // 修改
    onModify: function onModify(val) {
      this.chooseData = _lodash.default.cloneDeep(val);
      this.manageType = 'modify';
      this.$refs.managePop.dialogVisible = true;
    },
    // 批量操作
    onModifyMulti: function onModifyMulti() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请勾选需要修改的配置项！',
          type: 'warning'
        });
        return;
      }
      this.manageType = 'modifyMulti';
      this.chooseData = {};
      this.$refs.managePop.dialogVisible = true;
    },
    // 一键配置
    onModifyAll: function onModifyAll() {
      this.manageType = 'modifyAll';
      this.$refs.oneButtonManagePop.dialogVisible = true;
    },
    // 预设配置
    onModifyPreset: function onModifyPreset() {
      this.manageType = 'modifyPreset';
      this.$refs.presetOneButtonManagePop.dialogVisible = true;
    },
    // 分页
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.getList();
    },
    // 多选
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 单元格行合并处理
    objectSpanMethod: function objectSpanMethod(_ref8) {
      var row = _ref8.row,
        columnIndex = _ref8.columnIndex;
      var combineAmount = row.combineAmount;
      var showCombineColumnIndexList = [1, 2, 3]; // 需要合并的列（从0开始）
      if (showCombineColumnIndexList.indexOf(columnIndex) > -1) {
        if (combineAmount > 0) {
          return {
            rowspan: combineAmount,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    /** 配置值展示处理 */getDisplayConfigValue: function getDisplayConfigValue(list) {
      var displayValue = '';
      list.forEach(function (item) {
        if (item.weight != 0) {
          displayValue += "".concat(item.label, "\uFF1A\u6BD4\u4F8B ").concat(item.weight, "%\uFF0C\u8BA2\u5355\u4E0A\u9650 ").concat(item.limit, "\u5355\uFF1B");
        }
      });
      return displayValue;
    },
    getHeaderCellStyle: function getHeaderCellStyle() {
      return {
        backgroundColor: '#f8faff'
      };
    }
  })
};